var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3203 7.66667H11.3312M11.3203 11V15.4444M1.32031 11C1.32031 12.3132 1.57897 13.6136 2.08152 14.8268C2.58406 16.0401 3.32066 17.1425 4.24924 18.0711C5.17783 18.9997 6.28022 19.7362 7.49348 20.2388C8.70673 20.7413 10.0071 21 11.3203 21C12.6335 21 13.9339 20.7413 15.1471 20.2388C16.3604 19.7362 17.4628 18.9997 18.3914 18.0711C19.32 17.1425 20.0566 16.0401 20.5591 14.8268C21.0617 13.6136 21.3203 12.3132 21.3203 11C21.3203 8.34784 20.2667 5.8043 18.3914 3.92893C16.516 2.05357 13.9725 1 11.3203 1C8.66815 1 6.12461 2.05357 4.24924 3.92893C2.37388 5.8043 1.32031 8.34784 1.32031 11Z",
    stroke: "#3D4256",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBig);
export default __webpack_public_path__ + "static/media/info-big.da3408ee6a576df7cf37f11c26354bbd.svg";
export { ForwardRef as ReactComponent };